import type * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { cva, type VariantProps } from 'class-variance-authority';
import DashedLine from '@/assets/icons/dashed-line.svg?react';
import { cn } from '@/lib/utils';

const separatorVariants = cva('shrink-0', {
  variants: {
    variant: {
      solid: 'bg-border',
      dashed: 'bg-transparent',
    },
  },
  defaultVariants: {
    variant: 'solid',
  },
});

type SeparatorProps = React.ComponentProps<typeof SeparatorPrimitive.Root> &
  VariantProps<typeof separatorVariants>;

function Separator({
  className,
  orientation = 'horizontal',
  decorative = true,
  variant,
  ...props
}: SeparatorProps) {
  if (variant === 'dashed') {
    return <DashedLine className="w-full" />;
  }

  return (
    <SeparatorPrimitive.Root
      className={cn(
        separatorVariants({ variant }),
        'bg-border data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px',
        className,
      )}
      data-slot="separator"
      decorative={decorative}
      orientation={orientation}
      {...props}
    />
  );
}

export { Separator };
